<div class="employee-title">
  <!--  <nb-user name="{{ data.employee?.firstName }}"></nb-user>-->
  <app-avatar [avatarUrl]="data.employee?.avatarUrl" name="{{ data.employee?.firstName }}"></app-avatar>
  <nb-badge text="{{ data?.turnCnt }}" status="info" position="bottom left"></nb-badge>
</div>
<nb-list>
  <nb-list-item>
    <button nbButton class="add-turn" (click)="addTurn()"><nb-icon icon="plus-outline"></nb-icon></button
  ></nb-list-item>
  <!--  <nb-list-item>Turns: {{ data.turnCnt }}</nb-list-item>-->
  <nb-list-item *ngFor="let t of data.turns || []">
    <!--    normal turn-->
    <div
      *ngIf="t.type == 'normal'"
      class="j-turn-item"
      [ngClass]="{
        'j-turn-item--pending': t.paymentStatus === 'pending',
        'j-turn-blink': isBlink(t)
      }"
      (click)="updateTurn(t.id)"
    >
      <div class="j-turn-item-amt">
        {{ t?.amt | AmountPipe: false }} <span class="amt-splitter">/</span> {{ t?.tip | AmountPipe: false }}
      </div>
      <div class="j-turn-item-info">
        <nb-icon *ngIf="t.isClientRequested" icon="heart" status="danger"></nb-icon>
        <div *ngIf="!!t.paidInCashAmt" class="cash-icon"></div>
        <!--        <div *ngIf="!!t.redeemAmt" class="redeem-icon"></div>-->
        <nb-icon *ngIf="!!t.redeemAmt" icon="gift-outline" status="info"></nb-icon>
        <nb-icon *ngIf="!!t.note" icon="archive" status="warning"></nb-icon>
      </div>
    </div>
    <!--    crying turn-->
    <div *ngIf="t.type == 'crying'" class="j-turn-item" (click)="updateTurn(t.id)">
      <div class="j-turn-item-crying"></div>
    </div>
  </nb-list-item>
</nb-list>
<div class="total-amt text-center" *ngIf="data.turns?.length">
  <span>TOTAL:</span> {{ data?.totalAmt }} / {{ data?.totalTip }}
</div>
